import {set, observable, action, autorun} from 'mobx';
import {postData, formatElementsforExport} from '../utils/Utils';

import ElementModel from '../models/ElementModel'

export default class ElementStore {
    constructor(store) {
        this.store = store;

        //for storing incomplete responses

        autorun(() => {

            let data = {
                responseId: this.store.responseID,
                branchId: this.store.branchId,
                projectId: this.store.projectId,
                urlParams: this.store.getUrlParams(),
                tableName: (this.store.environment === 'production') ? 'mycampus_elems' : "mycampus_elems_test",
                mapData: {
                    elements: []
                }
            };
            data.mapData.elements = formatElementsforExport(this.elements);
            let stagingURL = 'https://dj3mppbaa4.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda_staging/myc-s3-lambda-staging-incompleteresponses';
            let productionURL = 'https://23tkwzjvr2.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda_incomplete_responses/myc-s3-lambda-incompleteresponses';
            let responseURL = productionURL;
            if (this.store.isStaging) {
                responseURL = stagingURL;
            }
            //piping any non PROD responses to staging responses bucket
            postData(responseURL, JSON.stringify(data), (response) => {
                console.log(response);
            });

        }, {
            delay: 300,
            onError: (e) => {

                console.log('mobx error:autorun: ', e);
            }

        });
    }

    @observable elements = [];

    @action addElement(newElement) {
        this.elements.push(newElement);
        return newElement;
    }

    @action updateElement(uuid, data) {
        let elementIndex = this.elements.findIndex(element => element.uuid === uuid);
        this.elements[elementIndex] = Object.assign({}, this.elements[elementIndex], data);
    }

    @action removeElement(uuid) {
        this.elements = this.elements.filter(element => element.uuid !== uuid);
    }

    @action createNewElement(icon, position, type) {
        let element = Object.assign({}, new ElementModel(icon, position, type));
        this.makePendingElement(element);
        return element;
    }

    @action deleteElements() {
        this.elements = [];
    }

    @action makePendingElement(element, editing = false) {
        set(this.store.pendingState, {element: Object.assign({}, element)});
        this.store.pendingState.editing = editing;
    }

    isNotPending(element) {
        if (!this.store.pendingState.element) {
            return true;
        } else if (element.uuid === this.store.pendingState.element.uuid) {
            return false;
        }
        return true;
    }

    inStore(newElement) {
        return this.elements.findIndex(element => element.uuid === newElement.uuid) !== -1;
    }
}


// WEBPACK FOOTER //
// ./src/stores/ElementStore.js